import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PositionState {
  positions: { id: number; name: string }[];
  dateRange: { start: string; end: string };
}

const initialState: PositionState = {
  positions: [],
  dateRange: { start: "", end: "" },
};

const positionSlice = createSlice({
  name: "position",
  initialState,
  reducers: {
    setPositions(state, action: PayloadAction<{ id: number; name: string }[]>) {
      state.positions = action.payload;
    },
    setDateRange(state, action: PayloadAction<{ start: string; end: string }>) {
      state.dateRange = action.payload;
    },
  },
});

export const { setPositions, setDateRange } = positionSlice.actions;
export default positionSlice.reducer;